<template>
  <div>
    <div class="card">
      <div class="card-header">
        <div class="row">
          <div class="col-md">
            <h5 class="card-title">Mitarbeiter</h5>
          </div>
          <div class="col-md text-right">
            <p-button class="mb-0 mt-0 mr-2" type="default" @click="addTrainer"><i class="bi bi-plus-circle" style="font-size: 12px;"></i> Neuer Mitarbeiter</p-button>
            <!--<p-button class="mb-0 mt-0" type="default" @click="startPsSync" v-if="paperShiftSyncEnabled == 1">Papershift Sync</p-button>-->
          </div>
        </div>
      </div>
      <div class="card-body row">
        <div class="col-sm-12">
          <div class="row mb-3">
            <div class="col-md-4 col-sm-12 mb-2 mb-md-0">
              <label class="d-block text-muted">Name</label>
              <el-input
                v-model="search"
                placeholder="Mitarbeiter suchen..."
              ><i slot="prefix" class="bi bi-search"></i></el-input>
            </div>
            <div class="col-md-4 col-sm-12 mb-2 mb-md-0">
              <label class="d-block text-muted">Arbeitsbereiche</label>
              <el-select
                v-model="selectedWorkAreas"
                multiple
                clearable
                collapse-tags
                placeholder="Arbeitsbereiche filtern..."
                class="w-100"
              >
                <el-option
                  v-for="option in workAreaOptions"
                  :key="option.value"
                  :label="option.label"
                  :value="option.value"
                ></el-option>
              </el-select>
            </div>
            <div class="col-md-4 col-sm-12 mb-2 mb-md-0">
              <label class="d-block text-muted">Unterweisungen</label>
              <el-select
                v-model="openInstructionFilter"
                clearable
                placeholder="Unterweisungen filtern..."
                class="w-100"
              >
                <el-option
                  v-for="option in openInstructionFilterOptions"
                  :key="option.value"
                  :label="option.label"
                  :value="option.value"
                ></el-option>
              </el-select>
            </div>
          </div>
          <el-table
            :data="filteredTrainer"
            header-row-class-name="text-primary"
            empty-text="Es konnten keine Mitarbeiter gefunden werden."
            v-loading="loading"
            @row-click="editTrainer"
          >
            <el-table-column prop="trainerName" label="Name" min-width="130"> </el-table-column>
            <el-table-column prop="trainerTelefon" label="Telefon" min-width="130"></el-table-column>
            <el-table-column prop="trainerMail" label="E-Mail" min-width="200"></el-table-column>
            <el-table-column label="Unterweisungen" min-width="95">
              <template slot-scope="scope">
                <span v-if="scope.row.openInstructionCount > 0" class="text-danger">
                  <i class="bi bi-exclamation-triangle-fill"></i>
                  {{ scope.row.openInstructionCount }} offen
                </span>
                <span v-else class="text-success">
                  <i class="bi bi-check-circle"></i>
                  keine offen
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="trainerErsteHilefeKursDatum" label="Erste-Hilfe-Kurs" min-width="110">
              <template slot-scope="scope">
                <span v-if="scope.row.trainerErsteHilefeKursDatum != '-'" :style="scope.row.trainerErsteHilefeKursExpired ? 'color: red; font-weight: bold;' : ''">
                  {{ scope.row.trainerErsteHilefeKursDatum }}
                  <i
                    class="bi bi-exclamation-triangle-fill text-danger ml-1"
                    v-if="scope.row.trainerErsteHilefeKursExpired"
                    title="Der Erste-Hilfe-Kurs des Mitarbeiters ist abgelaufen."
                  ></i>
                </span>
                <span v-else>-</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { db, fc } from "../../../../firebaseDb";
import { Table, TableColumn, Tooltip, Input, Loading, Select, Option, MessageBox } from "element-ui";
import moment from "moment-timezone";
import router from "../../../../main";
import store from "../../../../store";
import { httpsCallable } from "firebase/functions";
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Tooltip);
//Vue.use(Loading);

export default {
  components: {
    [Input.name]: Input,
    [Select.name]: Select,
    [Option.name]: Option,
    MessageBox
  },

  data() {
    return {
      trainer: [],
      lastSync: null,
      lastSyncTimestamp: null,
      search: "",
      selectedWorkAreas: [],
      openInstructionFilter: "all",
      loading: true,
      location: store.getters.userlocation,
      role: store.getters.userrole,
      paperShiftSyncEnabled: process.env.VUE_APP_ENABLE_PAPERSHIFT_SYNC,
      workAreaOptions: [
        { label: "Betreuer", value: "isEinweiser" },
        { label: "Retter", value: "isRetter" },
        { label: "Tagesverantwortlicher", value: "isHT" },
      ],
      openInstructionFilterOptions: [
        { label: "Alle", value: "all" },
        { label: "Nur offene", value: "open" },
        { label: "Keine offenen", value: "none" },
      ],
    };
  },
  created() {
    this.loadData();
    store.watch(
      (state) => state.userlocation,
      () => {
        this.location = store.getters.userlocation;
        this.loadData();
      }
    );
  },
  computed: {
    filteredTrainer() {
      return this.trainer.filter((data) => {
        const matchesSearch = !this.search || data.trainerName.toLowerCase().includes(this.search.toLowerCase());
        const matchesWorkAreas = this.selectedWorkAreas.every((workArea) => data[workArea] === true);

        let matchesOpenInstructions = true;
        if (this.openInstructionFilter === "open") {
          matchesOpenInstructions = data.openInstructionCount > 0;
        }
        if (this.openInstructionFilter === "none") {
          matchesOpenInstructions = data.openInstructionCount === 0;
        }

        return matchesSearch && matchesWorkAreas && matchesOpenInstructions;
      });
    },
  },
  methods: {
    loadData() {
      // get last Papershift sync time
      const lastSyncRef = db.collection("papershiftSyncStatus");
      var docname = "trainer"
      lastSyncRef
        .doc(docname)
        .get()
        .then((doc) => {
          this.lastSync = moment(new Date(doc.data().lastSync.seconds * 1000))
            .format("DD.MM.YY HH:mm")
            .toString();
          this.lastSyncTimestamp = doc.data().lastSync.seconds * 1000
        });

      // get list of trainers
      const trainerRef = db.collection("trainer");
      trainerRef.where('locationID', 'array-contains', this.location).orderBy("Name").onSnapshot((snapshotChange) => {
        const list = [];
        const countPromises = [];
        snapshotChange.forEach((doc) => {
          let trainerErsteHilfeKursExpired = false;
          let trainerErsteHilfeKursDatum = doc.data().ErsteHilfeKursDatum ? moment(doc.data().ErsteHilfeKursDatum.seconds * 1000).format("MM/YYYY") : "-";
          if(trainerErsteHilfeKursDatum != '-') {
            const ehkDate = moment(doc.data().ErsteHilfeKursDatum.seconds * 1000);
            const ehkDatePlusXYears = ehkDate.add(process.env.VUE_APP_ERSTE_HILFE_KURSE_INTERVALL_YEARS, 'years');
            if(ehkDatePlusXYears.isBefore(moment())) {
              trainerErsteHilfeKursExpired = true;
            }
          }
          if(trainerErsteHilfeKursDatum == "01/1970") {
            trainerErsteHilfeKursDatum = '-'
            trainerErsteHilfeKursExpired = false;
          }
          const row = {
            key: doc.id,
            trainerName: doc.data().Name,
            trainerID: doc.data().ID,
            trainerMail: doc.data().Mail,
            trainerTelefon: doc.data().Telefon,
            isEinweiser: doc.data().isEinweiser === true,
            isRetter: doc.data().isRetter === true,
            isKasse: doc.data().isKasse === true,
            isHT: doc.data().isHT === true,
            isVA: doc.data().isVA === true,
            trainerErsteHilefeKursDatum: doc.data().ErsteHilfeKursDatum ? trainerErsteHilfeKursDatum : '-',
            trainerErsteHilefeKursExpired: trainerErsteHilfeKursExpired,
            openInstructionCount: 0,
          };
          list.push(row);
          const p = db
            .collection('trainer')
            .doc(row.key)
            .collection('unterweisungen')
            .where('status', '==', 'offen')
            .get()
            .then((q) => { row.openInstructionCount = q.size; })
            .catch(() => { row.openInstructionCount = 0; });
          countPromises.push(p);
        });
        Promise.all(countPromises).then(() => {
          this.trainer = list;
          this.loading = false;
        });
      });
    },
    editTrainer(row, column) {
      router.push({ name: "editTrainer", params: { trainerId: row.key } });
    },
    addTrainer() {
      router.push({ name: "newTrainer" });
    },
    startPsSync() {
      if(new Date().getTime() - this.lastSyncTimestamp > 60000) { // greater 1min
        const loading = this.$loading({
          lock: true,
          text: 'Papershift Sync läuft...',
          spinner: 'el-icon-loading'
        });
        console.log("Start PS trainer sync")
        var getTrainer = httpsCallable(fc, "papershift-getPSTrainer");
        getTrainer([]).then((result) => {
          console.log('PS Trainer Sync done')
          this.loadData()
          loading.close()
        });
      } else {
        MessageBox.alert(
            "Mitarbeiter können erst 10 Minuten nach der letzten Synchronisation erneut aus Papershift abgerufen werden. Die letzte Synchronisation war am " + this.lastSync + " Uhr.",
            {
              confirmButtonText: "OK",
              type: "warning",
              callback: (action) => {},
            }
          );
      }
    },
  },
};
</script>
<style>
</style>
